import React from 'react';
import PropTypes from 'prop-types';
import { IconSavedBed, IconSavedWall } from '../Icons';
import { getVisualizerNoun, getSlugFromPathName } from '../../Utils/VisualizerUtils';
import { StyledFlexWrapper, StyledPinkOutlineButton } from '../VisualizerSaveModal/VisualizerSaveModalStyles';

var _ref2 = React.createElement(IconSavedBed, null);

var _ref3 = React.createElement(IconSavedWall, null);

var _ref4 = React.createElement(
  'h3',
  null,
  'Design sent!'
);

var _ref5 = React.createElement(
  'h4',
  null,
  'One step closer to your perfect space.'
);

var VisualizerEmailSuccess = function VisualizerEmailSuccess(_ref) {
  var closeModalFunc = _ref.closeModalFunc,
      relativeUrl = _ref.relativeUrl;

  var relativePathName = relativeUrl.split('?')[0];
  var slug = getSlugFromPathName(relativePathName);
  var visualzerNoun = getVisualizerNoun();
  return React.createElement(
    StyledFlexWrapper,
    { component: 'VisualizerEmailSuccess' },
    slug === 'visualizer' ? _ref2 : _ref3,
    _ref4,
    _ref5,
    React.createElement(
      StyledPinkOutlineButton,
      { onClick: closeModalFunc },
      'Keep Editing This ' + visualzerNoun
    ),
    React.createElement(
      StyledPinkOutlineButton,
      { as: 'a', href: relativePathName },
      'Design A New ' + visualzerNoun
    )
  );
};

VisualizerEmailSuccess.propTypes = {
  closeModalFunc: PropTypes.func.isRequired,
  relativeUrl: PropTypes.string.isRequired
};

export default VisualizerEmailSuccess;